<template>
  <v-container tag="section" class="content">
    <v-row v-if="this.$auth.user().id">
      <v-col class="text-right">
        <v-btn v-if="this.$route.name != 'frontend.index' || filters.types != null" @click="filters.types= null" class="mr-1">
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn :color="currentColor()" :to="{ name: 'frontend.my-family' }" class="mr-0">
          {{ $t("my_family.menu_button") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="text-right">
        <v-btn v-if="this.$route.name != 'frontend.index' || filters.types != null" @click="filters.types= null">
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn :to="{ name: 'auth.login' }">
          {{ $t("Login") }} / {{ $t("register.button_submit") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-card color="rgb(255, 255, 255, 0.3)" class="mt-5 mb-5 pa-3">
      <v-card-text
        v-if="$i18n.locale == 'de'"
        class="text-center"
        v-html="this.$store.state.modules.options.app_intro"
      >
      </v-card-text>
      <v-card-text
        v-else
        class="text-center"
        v-html="this.$store.state.modules.options.app_intro_it"
      >
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-col>
        <v-progress-linear
          :color="currentColor()"
          indeterminate
        ></v-progress-linear>
      </v-col>
    </v-row>
    <template v-else>
      <template v-if="filters.types === null">
        <v-card :color="currentColor()" class="text-center">
          <v-card-text>
            <h3 class="mb-5">{{ $t("frontend_home_filterheading") }}:</h3>
            <v-row justify="space-around" align="stretch" class="mb-5">
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="4"
                xl="4"
                v-for="(item, index) in filterTypes"
                :key="index"
              >
                <v-card color="white" height="100%" @click="setFilter(item)">
                  <v-card-text>
                    <br />
                    <p class="mt-5 title">
                      {{
                        item[
                          `name${
                            $i18n.locale == "de" ? "" : "_" + $i18n.locale
                          }`
                        ]
                      }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-if="filterTypes.length == 5"></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <template v-else>
        <v-alert dense type="info" v-if="items && items.length === 0">{{
          $t("no_result")
        }}</v-alert>
        <v-row
          v-else
          class="filters"
          :style="
            this.$store.state.modules.options.app_color
              ? 'background-color: ' +
                this.$store.state.modules.options.app_color +
                '!important;'
              : ''
          "
        >
          <v-col cols="auto" class="d-none d-sm-flex">
            <p class="pt-5">{{ $t("filters") }}</p>
          </v-col>
          <v-col cols="12" class="col-12 col-sm-auto">
            <v-select
              v-model="filters.types"
              :items="filterTypes"
              :item-text="$i18n.locale == 'de' ? 'name' : 'name_it'"
              item-value="id"
              :placeholder="this.$t('choose_type')"
              clearable
              outlined
              background-color="white"
            >
            </v-select>
          </v-col>
          <v-col cols="12" class="col-12 col-sm-auto">
            <v-select
              v-model="filters.locations"
              :items="filterLocations"
              :item-text="$i18n.locale == 'de' ? 'name' : 'name_it'"
              item-value="id"
              :placeholder="this.$t('choose_location')"
              multiple
              clearable
              outlined
              background-color="white"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(item, index) in filteredItems"
            :key="index"
          >
            <v-card class="mx-auto mt-0" color="white" max-width="100%">
              <v-img
                class="white--text align-end"
                height="300px"
                :src="item.image || '/img/background.jpg'"
                gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.33)"
              >
                <v-card-title v-if="$i18n.locale == 'de'" class="white--text">{{
                  item.name
                }}</v-card-title>
                <v-card-title v-else class="white--text">{{
                  item.name_it
                }}</v-card-title>
              </v-img>

              <v-card-text>
                <template v-if="item.from">
                  <div>
                    <b>{{ $t("period") }}:</b> {{ item.from | formatDate }}
                    <span v-if="item.to">- {{ item.to | formatDate }}</span>
                  </div>
                </template>
                <template v-if="item.location.name">
                  <div>
                    <b>{{ $t("Location") }}:</b>
                    {{
                      $i18n.locale == "de"
                        ? item.location.name
                        : item.location.name_it
                    }}
                  </div>
                </template>

                <template v-if="item.description">
                  <hr class="my-2" />
                  <div
                    v-if="$i18n.locale == 'de'"
                    v-html="item.description"
                  ></div>
                  <div v-else v-html="item.description_it"></div>
                </template>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="editItem(item)" color="orange">
                  {{ $t("more") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </template>
  </v-container>
</template>

<script>
import { fetchItems } from "../shared/services";
import Swal from "sweetalert2";

export default {
  name: "app-frontend-list",
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: -1
      },
      total: 0,
      search: "",
      items: [],
      courseDialog: false,
      currentCourse: null,
      filters: {
        types: null,
        locations: null
      }
    };
  },

  created() {
    this.getData();
  },
  mounted() {
    this.$auth.fetch().then(() => {
      if (
        this.$auth.user().id &&
        this.$auth.user().people.privacy_verification_needed
      ) {
        Swal.fire({
          icon: "info",
          title: this.$t("privacy_page.title"),
          text: this.$t("privacy_page.subtitle")
        }).then(() => {
          this.$router.push({ name: "frontend.privacy" });
        });
      }
    });
  },
  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      if (response.data) {
        this.items = response.data;
      }

      this.loading = false;
    },
    openDialog(item) {
      this.currentCourse = item;
      this.courseDialog = true;
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "frontend.edit", params: { id: url } });
    },
    setFilter(item) {
      this.filters.types = item.id;
    },
    currentColor() {
      return this.$store.state.modules.options.app_color
        ? this.$store.state.modules.options.app_color
        : "primary";
    }
  },
  computed: {
    filterTypes() {
      let courseTypes = [
        {
          id: 0,
          name: this.$t("all_course_types"),
          name_it: this.$t("all_course_types"),
          sort_order: 0
        }
      ];
      let courseTypeIds = [];

      this.items
        .map(item => item.courseType)
        .forEach(item => {
          if(item){
            if (courseTypeIds.includes(item.id)) {
              return;
            }
            courseTypeIds.push(item.id);
            courseTypes.push(item);
          }
        });

      return _.sortBy(courseTypes, "sort_order");
    },
    filterLocations() {
      return this.items.map(item => item.location);
    },
    filteredItems() {
      let results = this.items;
      if (this.filters.locations && this.filters.locations.length) {
        results = results.filter(obj => {
          return this.filters.locations.includes(obj.location_id);
        });
      }
      if (this.filters.types) {
        results = results.filter(obj => {
          return this.filters.types === obj.course_type_id;
        });
      }

      return results;
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler: _.debounce(function () {
        this.getData();
      }, 300), // 300ms debounce delay
      immediate: false,
    },
  }
};
</script>

<style lang="scss" scoped>
.filters {
  background-color: #faa61a;
  margin: 0;
  border-radius: 5px;
}

.background {
  filter: blur(4px);
  position: absolute;
  width: 100%;
  height: 100%;
}

h1.main {
  font-size: 200%;
  line-height: 200%;
}

.v-card__title{
word-break: break-word;
}

</style>
